import { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { BUTTON_COLORS } from "components/DesignComponents/Button/types/enums";
import AuthContext from "context/auth/authContext";
import { isAuthenticatorType } from "shared/functions";
import { useApi } from "shared/hooks/useApi";
import { ENDPOINTS } from "shared/types/enums";

import ContentFrameGroup from "../../ContentFrameGroup";
import DeleteAccountModal from "./DeleteAccountModal";

const DeleteAccount = () => {
    const { authType } = useContext(AuthContext);

    const { t } = useTranslation();
    const { postData, handleResponse } = useApi();

    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const sendCodeToEmail = async () => {
        try {
            setIsLoading(true);
            await postData(ENDPOINTS.TfaSendEmail);
            setIsOpen(true);
        } catch (error) {
            handleResponse(error);
        }

        setIsLoading(false);
    };

    const handleClick = () => {
        if (isAuthenticatorType(authType)) {
            setIsOpen(true);
        } else {
            sendCodeToEmail();
        }
    };

    const closeDialog = () => setIsOpen(false);

    return (
        <>
            <ContentFrameGroup
                title={t("Security##delete account##settings##title")}
                description={t(
                    "Security##delete account##settings##description"
                )}
                buttonText={t("Button##delete")}
                buttonColor={BUTTON_COLORS.Critical}
                isLoading={isLoading}
                onButtonClick={handleClick}
            />

            <DeleteAccountModal isOpen={isOpen} close={closeDialog} />
        </>
    );
};

export default DeleteAccount;
